export default "__VITE_ASSET__sv$uKBMH__"